import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

const useFlightsApi = (activityId: string, enabled = true) => {
  const { data, ...rest } = useQuery({
    ...MediaPlan.getFlightsListQueryOptions({
      params: { activityId },
    }),
    enabled,
  });

  return { data: data?.data, ...rest };
};

export default useFlightsApi;
